<template lang="pug">
	.range-selector
		DxRangeSelector(
			:id="id"
			:data-source="rangeDataSource"
			v-model:value="rangeValue"
			:style="{ height: '150px' }"
			:data-source-field="rangeSourceField"
			:disabled="isLoading"
			@value-changed="v => selectRange(v)"
		)
			DxMargin(:top="5")
			DxScale(
				:start-value="startValue"
				:end-value="endValue"
			)
				DxMinorTickInterval(:days="minorTickInterval")
				DxTickInterval(:days="tickInterval")
				DxMinRange(:days="minRange")
			DxBehavior(:call-value-changed="'onMovingComplete'")
			DxSliderMarker(format="dd MMM yyyy")
			DxChart
				template(v-for="item in series")
					DxSeries(
						:key="item.value"
						:argument-field="item.field"
						:value-field="item.value"
						:palette="palette"
					)
				DxValueAxis(:min="0")
</template>

<script>
	import {
		DxRangeSelector,
		DxMargin,
		DxScale,
		DxMinorTick,
		DxMinorTickInterval,
		DxTickInterval,
		DxMinRange,
		DxMaxRange,
		DxSliderMarker,
		DxChart,
		DxSeries,
		DxValueAxis,
		DxBehavior,
	} from 'devextreme-vue/range-selector';
	import VueTypes from "vue-types";

	export default {
		translationCategory: 'logs.components.RangeSlider',
		name: "LogsRangeSelector",
		props: {
			id: VueTypes.string.def(`chart-id-${(+new Date).toString(16)}`),
			rangeSourceField: VueTypes.string.def('date'),
			rangeDataSource: VueTypes.array.def([]),
			rangeValue: VueTypes.array.def([]),
			series: VueTypes.array.def([]),
			startValue: VueTypes.any.def(null),
			endValue: VueTypes.any.def(null),
			isLoading: VueTypes.bool.def(false),
			palette: VueTypes.any.def('Soft Pastel'),
		},
		components: {
			DxRangeSelector,
			DxMargin,
			DxScale,
			DxMinorTick,
			DxMinorTickInterval,
			DxTickInterval,
			DxMinRange,
			DxMaxRange,
			DxSliderMarker,
			DxChart,
			DxSeries,
			DxValueAxis,
			DxBehavior,
		},
		computed: {
			diffDays() {
				const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
				return Math.round(Math.abs((new Date(this.startValue) - new Date(this.endValue)) / oneDay));
			},
			minorTickInterval() {
				return 1;
			},
			tickInterval() {
				return 1;
			},
			minRange() {
				return 1;
			},
		},
		methods: {
			selectRange(v) {
				this.$emit('selectRange', v.value);
			},
		},
	}
</script>

<style lang='scss' scoped>
	.range-selector {
		display: block;
		width: 100%;
		background: #FFFFFF;
		border: 1px solid #f3f3f3;
		border-radius: 3px;
	}
</style>
